import React from 'react';
import { OpForm } from 'components/customAntd/DLS/OpForm/OpForm';
import { OpRow } from "components/customAntd/DLS/OpRow/OpRow";
import { OpCol } from "components/customAntd/DLS/OpCol/OpCol";
import { DATE_FORMAT } from 'constants/dates';
import { useTranslation } from 'react-i18next';

const ActivityLogContent: React.FC = () => {
    const { t } = useTranslation();
    return (
        <>
            <OpForm.Input label={t('activityLog.form.activity')} name="activity" />

            <OpForm.Input label={t('activityLog.form.user')} name="user" />

            <OpRow gutter={16}>
                <OpCol span={12}>
                    <OpForm.DatePicker name="date" label={t('activityLog.form.date')} format={DATE_FORMAT} style={{ width: '100%' }} disabled />
                </OpCol>
                <OpCol span={12}>
                    <OpForm.TimePicker name="time" label={t('activityLog.form.time')}
                        format="h:mm A"
                        use12Hours
                        minuteStep={5}
                        needConfirm={false}
                        style={{ width: '100%' }}
                        disabled
                    />
                </OpCol>
            </OpRow>
            <OpForm.TextAreaInput readOnly rows={4} label={t('activityLog.form.activityDetails')} name="activityDetails" />
        </ >
    );
};

export default ActivityLogContent;
